const SERVER_BASE_URL = import.meta.env.VITE_SERVER_BASE_URL;

export const buildLoginUrl = (redirectPath: string | null): string => {
  const baseUrl = `${SERVER_BASE_URL}/login/auth`;
  if (!redirectPath) {
    return baseUrl;
  }
  // Only pass the redirect to server path (not full url)
  const fullRedirectUrl = encodeURIComponent(redirectPath);
  return `${baseUrl}?redirectUrl=${fullRedirectUrl}`;
};
